import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { LoginService } from '../../features/auth/login.service';
import { tap } from 'rxjs/operators';
import { AlertService } from '../../shared/components/alert/alert';

@Injectable({
  providedIn: 'root',
})
export class UploadImageService {
  constructor(
    private http: HttpClient,
    private alertService: AlertService,
  ) {}
  baseUrl: string = environment.baseUrl;

  uploadImageForAdmin(folder: string, selectedFile: any): Observable<any> {
    const formData = new FormData();
    formData.append('image', selectedFile);

    const params = new HttpParams().set('folder', folder);

    return this.http.post(`${this.baseUrl}/images/admin/uploads`, formData, {
      params,
    }).pipe(
      tap((res: any) => {
        if (res.returncode === '200' && res.message === 'ECONNREFUSED') {
          this.alertService.warning('VPN opening alert warning');
        }
      })
    );
  }

  uploadImageForUser(selectedFile: any): Observable<any> {
    const formData = new FormData();
    formData.append('image', selectedFile);

    return this.http.post(`${this.baseUrl}/images/uploads`, formData).pipe(
      tap((res: any) => {
        if (res.returncode === '200' && res.message === 'ECONNREFUSED') {
          this.alertService.warning('VPN opening alert warning');
        }
      })
    );
  }

  deleteImage(imageUrl: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/images/deleteimage`, {
      imageurl: imageUrl,
    });
  }
}
